/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

export const RNABaseAvatar = () => (
  <>
    <symbol id="rna-base" viewBox="-16 0 65 65" width="65" height="95">
      <rect
        width="22.5"
        height="22.5"
        data-actual-width="31.82"
        data-actual-height="31.82"
        rx="1"
        x="-11.25"
        y="-11.25"
        transform="rotate(45)"
        className="monomer-body"
      />
    </symbol>
    <symbol
      id="rna-base-selection"
      viewBox="-15.75 -0.25 65 65"
      width="65"
      height="95"
    >
      <rect
        width="21"
        height="21"
        rx="1"
        x="-10.5"
        y="-10.5"
        transform="rotate(45)"
        stroke="#0097A8"
        strokeWidth="1.5"
        fill="none"
      />
    </symbol>
    <symbol id="rna-base-variant" viewBox="-16 0 65 65" width="65" height="94">
      <rect
        width="21.5"
        height="21.5"
        data-actual-width="30"
        data-actual-height="30"
        stroke="#585858"
        strokeWidth="0.5"
        rx="1"
        x="-10.25"
        y="-10.25"
        transform="rotate(45)"
        className="monomer-body"
      />
    </symbol>
    <symbol
      id="rna-base-modified-background"
      viewBox="0 0 32 10"
      width="30"
      height="9"
      x="0.8"
      y="10.8"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30156 10C6.03634 10 5.78199 9.89464 5.59445 9.70711L1.1508 5.26346C0.760279 4.87293 0.760279 4.23977 1.1508 3.84924L4.70715 0.292893C4.89469 0.105357 5.14904 0 5.41426 0H26.5858C26.851 0 27.1054 0.105357 27.2929 0.292893L30.8493 3.84924C31.2398 4.23977 31.2398 4.87293 30.8493 5.26346L26.4056 9.70711C26.2181 9.89464 25.9637 10 25.6985 10H6.30156Z"
        fill="#333333"
        fillOpacity="0.6"
      />
    </symbol>
    <symbol
      id="rna-base-autochain-preview"
      viewBox="0 0 36 36"
      width="36"
      height="36"
      data-actual-width="36"
      data-actual-height="36"
    >
      <path d="M2.77636 20.2837L1.83359 19.341C1.05254 18.5599 1.05254 17.2936 1.83359 16.5125L2.77468 15.5715" />
      <path d="M15.7398 33.2465L16.6826 34.1893C17.4636 34.9704 18.73 34.9704 19.511 34.1893L20.4521 33.2482" />
      <path d="M20.4412 2.61969L19.4984 1.67691C18.7173 0.89586 17.451 0.895861 16.67 1.67691L15.7289 2.618" />
      <path d="M33.4046 15.5825L34.3474 16.5252C35.1284 17.3063 35.1284 18.5726 34.3474 19.3537L33.4063 20.2948" />
      <path d="M21.6425 32.0586L23.4089 30.2921" />
      <path d="M24.5747 29.126L26.3412 27.3595" />
      <path d="M27.5073 26.1934L29.2737 24.4269" />
      <path d="M30.4753 23.2256L32.2418 21.4591" />
      <path d="M3.96771 21.4492L5.73546 23.217" />
      <path d="M6.90216 24.3838L8.6699 26.1515" />
      <path d="M9.83673 27.3184L11.6045 29.0861" />
      <path d="M12.8069 30.2881L14.5747 32.0558" />
      <path d="M3.96497 14.3809L5.73145 12.6144" />
      <path d="M6.89728 11.4482L8.66376 9.68176" />
      <path d="M9.82977 8.5166L11.5963 6.75012" />
      <path d="M12.7979 5.54785L14.5643 3.78137" />
      <path d="M21.6326 3.78418L23.4003 5.55192" />
      <path d="M24.567 6.71875L26.3347 8.48649" />
      <path d="M27.5016 9.65332L29.2693 11.4211" />
      <path d="M30.4718 12.623L32.2395 14.3908" />
    </symbol>
  </>
);
